import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TipoActividadService } from '@services/tipo-actividad.service'; // Servicio
import { GuiMsjService } from '@services/shared/gui-msj.service';
import { MediaService } from '@services/shared/media.service';
import { Subscription } from 'rxjs';
import { TipoActividad } from 'src/app/app.config/app.config-beneficios';
import { readImagePreview } from '@shared/utils/image-upload.util';

@Component({
  selector: 'app-alta-categoria',
  templateUrl: './alta-categoria.component.html',
  styleUrls: ['./alta-categoria.component.scss']
})
export class AltaCategoriaComponent implements OnInit {

  // Upload
  flagSelectFile = false;
  selectedFile: any;
  value = 0;
  cargandoArchivo = false;
  subscriptionAvance: Subscription;
  condition = false;
  fileName = 'No file selected';
  file: File;

  /* ripple */
  centered = false;
  disabled = false;
  unbounded = false;

  /* img portada */
  fileAttr = 'Choose File';

  radius: number;
  color: string;

  flagProcesando = false;

  imageUrl: string | ArrayBuffer = null;
  esHeic = false;
  
  // FORM
  form: FormGroup;

  categoria: TipoActividad;

  constructor(
    private router: Router,
    private tipoActividadService: TipoActividadService,
    private mediaService: MediaService,
    private guiMsjService: GuiMsjService,) {
      this.createForm();
    
      }

  ngOnInit(): void {}

  createForm() {
    this.form = new FormGroup({
      denominacion: new FormControl('', [Validators.required]),
      imagen: new FormControl('', [Validators.required]),
      size: new FormControl('', [Validators.required]),
    });
  }

  async post(){
      this.flagProcesando = true;

      try {
          const tipoActividad: TipoActividad = await this.tipoActividadService.post(await this.setDataForma());

          // El servicio ya notificó el error; no continuar con la subida.
          if (!tipoActividad) {
              return;
          }

          await this.uploadFile(this.selectedFile, tipoActividad._id);
          this.router.navigateByUrl('/tramites-configuracion');
      } finally {
          this.flagProcesando = false;
      }
    }
  /* UPLOAD */

    /* subo archivo con observable*/
    subscribeAvanceUpload(){
      this.subscriptionAvance = this.mediaService.getAvance().subscribe(resp => {
      if (resp) {
          this.value = resp.value;
      } else {
          this.value = 0;
          }
      });
  }

  openFileSelected(event) {
      this.selectedFile = <File> event.target.files[0];
  }

  onChangeFile(file: File, event){
    if(file){
      this.openFileSelected(event);
      this.fileName = file.name;
      this.file = file;
      readImagePreview(file,
        value => {
          this.imageUrl = value;
          this.esHeic = false;
        },
        () => {
          this.esHeic = true;
          this.imageUrl = null;
        }
      );
    }
  }

  async uploadFile(selectedFile: File, idtipoactividad: string) {
    this.cargandoArchivo = true;
    try {
        const result = await this.mediaService.uploadImgTipoActividad(selectedFile, idtipoactividad);
        if (!result) throw new Error('Upload fallido');
    } catch (error) {
        this.guiMsjService.msjFormSubmit('uploadDocumentERROR');
    } finally {
        this.cargandoArchivo = false;
    }
  }

  /* FIN UPLOAD */

  async setDataForma(): Promise<TipoActividad> {
    const data: TipoActividad = {
      denominacion: this.form.value.denominacion,
      size: this.form.value.size,
    }
    return data;
  }
}
